import iconInfo from '../../icons/info.svg?raw'
import iconMessage from '../../icons/message.svg?raw'
import iconGoblet from '../../icons/goblet.svg?raw'
import iconGamepad from '../../icons/gamepad.svg?raw'
import { Point } from 'pixi.js'

export interface GlobalEnv {
  nowDayNumber: number
  debugMode: boolean
  isArchive: boolean
  publicPath: string
  year: string
}

export const Env: GlobalEnv = {
  nowDayNumber: window.nowDayNumber || 24,
  debugMode: /true/.test(__DEBUG_MODE__ ?? 'false'),
  isArchive: !!window.isArchive,
  publicPath: __PUBLIC_PATH__ ?? '/',
  year: __YEAR__ ?? '2012',
}

export const isArchive = Env.isArchive
export const year = Env.year
export const projectName = `advent${year}`
export const projectHeadline = `Adventní kalendář ${year}`
export const debugMode = Env.debugMode
export const nowDayNumber = Env.nowDayNumber
export const ITEM_DELAY = 300 //ms - hover over item delay before item sound starts to play

// TODO: Reuse colors in constants.scss
// export const style = {
//   item: {
//     bullet: {
//       FONT_BASE: 'Playpen Sans',

//       BULLET_NUMBER_TEXT_COLOR: '0XB53F26',
//       BULLET_NUMBER_BACKGROUND_COLOR: '0XFFFFFF',
//       BULLET_NUMBER_BACKGROUND_ALPHA: 1,
//       BULLET_NUMBER_STROKE_COLOR: '0X000000',

//       BULLET_LABEL_TEXT_COLOR: '0XB53F26',
//       BULLET_LABEL_BACKGROUND_COLOR: '0XFFFFFF',
//       BULLET_LABEL_BACKGROUND_ALPHA: 1,
//       BULLET_LABEL_STROKE_COLOR: '0X000000',

//       LABEL_TEXT_X_OFFSET: 25,
//       LABEL_TEXT_X_PADDING: 15,
//       LABEL_WIDTH: 500,
//       LABEL_HEIGHT: 34,
//       BULLET_RADIUS: 18,

//       DOT_RADIUS: 10,
//       DOT_COLOR: '#FFB3A3',

//       SHOW_TWEEN_DURATION: 0.2,
//     },
//   },
// }

// todo set values
// todo add rectangle layers to PSD file and export to positionsConfig.json as sceneSize : {x:, y:}, minViewSize: {x:, y:}, viewSize: {x:, y:}}
export const dimensions = {
  // full with parallax
  SCENE_WIDTH: 2470,
  SCENE_HEIGHT: 1516,

  // always visible - scale begin
  MIN_WIDTH: 2310,
  MIN_HEIGHT: 1476, //for now should be equal to MAX_HEIGHT otherwise css container resizing doesn't work

  // full size without parallax 2:1 ratio
  MAX_WIDTH: 2410,
  MAX_HEIGHT: 1326,

  // DESKTOP_BREAKPOINT: 1024,
}

// todo add rect to each parallax layer in PSD file and export to positionsConfig.json as {"name": "layer_1", size: {x: 1660, y: 830}, ...}}
export const parallaxLayerDimensions: Point[] = [
  new Point(2510 - 60, 1476 - 60), //layer 1 - far
  new Point(2510 - 50, 1476 - 50),
  new Point(2510 - 30, 1476 - 40),
]

export const positions = {
  initialRatio: new Point(0.5, 0.5),
}

export const paths = {
  DATA_PATH: `${Env.publicPath}dat/`,
  SPRITES_PATH: `${Env.publicPath}spritesheets/`,
  IMAGES_PATH: `${Env.publicPath}images/`,
  AUDIO_SFX_PATH: `${Env.publicPath}audio/sfx/`,
  AUDIO_ITEMS_PATH: `${Env.publicPath}audio/items/`,
  // AUDIO_AMBIENT_PATH: `${Env.publicPath}audio/ambient/`,
  AUDIO_MUSIC_PATH: `${Env.publicPath}audio/music/`,
}

export const audio = {
  GLOBAL_VOLUME: 1,
  ITEMS_VOLUME: 1,
  music: [{ name: 'hudba_1', volume: 0.5 }],
  // ambient: { name: 'atmosfera', volume: 0.4 },
}

export const animation = {
  SHOW_TWEEN_DURATION: 0.4,
}

// Items that only have phase 2 (hover state) and no phase 1 (normal state)
export const ITEMS_PHASE2_ONLY: string[] = [
  'baf',
  'dopis',
  'kometa',
  'kostel',
  'okno',
  'ovce',
  'prskavky',
  'vino',
  'vystava',
]
